module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('community.creator.title')))])]), _vm._v(" "), _c('div', [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.createCommunity($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.name'),
      "description": _vm.$t('community.name.description'),
      "state": _vm.communityCreateNameState,
      "feedback": _vm.communityCreateNameFeedback
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "formatter": _vm.communityCreateNameFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.communityCreate.name),
      callback: function($$v) {
        _vm.communityCreate.name = $$v
      },
      expression: "communityCreate.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.slug'),
      "description": _vm.$t('community.slug.description'),
      "state": _vm.communityCreateSlugState,
      "feedback": _vm.communityCreateSlugFeedback
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": _vm.communityCreateSlugAvailable
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": "",
      "formatter": _vm.communityCreateSlugFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.communityCreate.slug),
      callback: function($$v) {
        _vm.communityCreate.slug = $$v
      },
      expression: "communityCreate.slug"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.tag'),
      "description": _vm.$t('community.tag.description'),
      "state": _vm.communityCreateTagState,
      "feedback": _vm.communityCreateTagFeedback
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.communityCreate.tag),
      callback: function($$v) {
        _vm.communityCreate.tag = $$v
      },
      expression: "communityCreate.tag"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.website.optional'),
      "state": _vm.communityCreateWebsiteState,
      "feedback": _vm.communityCreateWebsiteFeedback
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.communityCreate.website),
      callback: function($$v) {
        _vm.communityCreate.website = $$v
      },
      expression: "communityCreate.website"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.createCommunity
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.create.community')) + "\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b38dd2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommunityCreator.vue
// module id = 537
// module chunks = 0